import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChatCommentLine = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M1.66663 5.63754C1.66663 3.44619 3.41466 1.66699 5.5746 1.66699H14.0095C16.1696 1.66699 17.9166 3.4464 17.9166 5.63754V11.4975C17.9166 13.6884 16.1698 15.4688 14.0095 15.4688H13.1192C12.8085 15.4688 12.5105 15.5939 12.2906 15.8176L11.1055 17.0217C10.3801 17.7599 9.20364 17.7597 8.47814 17.022L7.29353 15.8176C7.07357 15.5939 6.77558 15.4688 6.46487 15.4688H5.5746C3.41446 15.4688 1.66663 13.6886 1.66663 11.4975V5.63754ZM5.5746 2.93367C4.10859 2.93367 2.91663 4.14213 2.91663 5.63754V11.4975C2.91663 12.9931 4.10879 14.2021 5.5746 14.2021H6.46487C7.10767 14.2021 7.72431 14.4611 8.17889 14.9234L9.36348 16.1279C9.60106 16.3694 9.98314 16.3689 10.2194 16.1283L11.4051 14.9234C11.8597 14.4613 12.4765 14.2021 13.1192 14.2021H14.0095C15.4751 14.2021 16.6666 12.9932 16.6666 11.4975V5.63754C16.6666 4.14192 15.4753 2.93367 14.0095 2.93367H5.5746Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6.50713 9.99932C6.50713 9.64955 6.78694 9.36598 7.13213 9.36598H10.184C10.5292 9.36598 10.809 9.64955 10.809 9.99932C10.809 10.3491 10.5292 10.6327 10.184 10.6327H7.13213C6.78694 10.6327 6.50713 10.3491 6.50713 9.99932Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6.50713 6.76998C6.50713 6.4202 6.78694 6.13664 7.13213 6.13664H12.4511C12.7962 6.13664 13.0761 6.4202 13.0761 6.76998C13.0761 7.11977 12.7962 7.40332 12.4511 7.40332H7.13213C6.78694 7.40332 6.50713 7.11977 6.50713 6.76998Z",
			fill: "currentColor"
		})
	]
});
export default SvgChatCommentLine;
